export default __webpack_public_path__ + "static/media/repayment-channel-icon6.7e312cc1.png";